import { render, staticRenderFns } from "./UserWealthRecordList.vue?vue&type=template&id=42d6cb01&scoped=true&lang=pug&"
import script from "./UserWealthRecordList.vue?vue&type=script&lang=ts&"
export * from "./UserWealthRecordList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d6cb01",
  null
  
)

export default component.exports